<template>
  <div>
    <el-dialog :fullscreen="fullscreen" :modal="false" :visible.sync="dialogVisible">
      <div slot="title">
        <div class="editor-head">
          <div class="fx-navigation-bar flex justify-between">
            <div class="navigation-left w-1/2">
              <div class="nav-title flex flex-grow items-center place-items-center">
                <i
                  class="bi bi-chevron-left text-2xl text-slate-400" style="height: 24px;"
                  @click="dialogVisible=false"
                />
                <div class="fx-title-editor nav-title-editor">
                  <div class="input-container">
                    <input
                      v-model="config.title" v-autowidth="{maxWidth: '250px', minWidth: '20px', comfortZone: 0}"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="mx-2">
              <el-button type="primary" @click="onSubmit">保存</el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="h-full">
        <el-container>
          <el-main>
            <el-container>
              <el-aside class="border-r bg-gray-100" width="250px">
                <div class="fx-dash-editor-data-block">
                  <div class="block-head">
                    <span class="block-title">数据源</span><span
                      class="head-right right-link"
                      @click="SourceDialogVisible=true"
                    >更改数据源</span>
                  </div>
                  <ul class="block-list">
                    <li class="normal-item list-item">
                      <i
                        class="bi bi-cart"
                        style="color: rgb(245, 164, 57);"
                      /><span class="item-title">{{ config.form.name }}</span>
                    </li>
                  </ul>
                </div>
                <div class="fx-dash-editor-data-block">
                  <div class="block-head"><span class="block-title">数据获取权限</span></div>
                  <div class="block-auth">
                    <div class="x-combo" tabindex="0">
                      <el-select class="w-full" value="1">
                        <el-option value="1" label="全部" />
                        <el-option value="2" label="全部" />
                      </el-select>
                    </div>
                    <div class="auth-desc">成员访问组件时可以查看组件中的全部数据和字段。</div>
                  </div>
                  <div class="block-divider" />
                </div>
                <el-divider />
                <div class="fx-dash-editor-data-block column-auto">
                  <div class="block-head">
                    <span class="block-title">字段</span>
                    <!--                    <span class="head-right right-btn">-->
                    <!--                      <i class="bi bi-search" />-->
                    <!--                    </span>-->
                    <!--                    <span class="head-right right-btn">-->
                    <!--                      <i class="bi bi-plus" />-->
                    <!--                    </span>-->
                  </div>
                  <div class="block-main">
                    <ul class="block-list">
                      <draggable
                        :sort="false"
                        class="dragArea list-group"
                        :group="{ name: 'people1', pull: 'clone', put: false }"
                        :clone="cloneAction"
                        :list="fields"
                        @change="onDragChange"
                        @start="onDragStart"
                        @end="onDragEnd"
                      >
                        <li
                          v-for="item in fields"
                          :key="item.name"
                          class="dash-source-field list-item"
                        >
                          <i class="bi bi-people" /><span class="item-title">{{ item.text }}</span>
                        </li>
                      </draggable>
                    </ul>
                  </div>
                </div>
              </el-aside>
              <el-container class="px-2 py-4 bg-gray-100" style="display: block;">
                <div class="fx-dash-editor-main-axis-line with-combo">
                  <div class="line-label items-center">
                    显示字段
                    <!--                    <div class="x-combocheck" tabindex="0">-->
                    <!--                      <i class="bi bi-plus" />-->
                    <!--                    </div>-->
                  </div>
                  <draggable
                    :sort="false"
                    :draggable="draggable"
                    :list="config.fields"
                    class="w-full h-full"
                    group="people1"
                    ghost-class="invisible"
                  >
                    <div v-if="config.fields.length === 0" style="padding-left: 88px;font-size: 12px;color: gray;">
                      拖动左侧字段到此处来添加显示字段
                    </div>

                    <ul v-else class="line-main clear-both">
                      <li v-for="item in config.fields" :key="item.tag" class="axis-field">
                        <div>
                          <div class="fx-custom-dash-tag group">
                            <div class="tag-wrapper style-green">
                              <i class="bi bi-chevron-down" />
                              <div class="text-wrapper"><span class="tag-text">{{ item.text }}</span></div>
                              <i class="bi bi-x-circle-fill invisible group-hover:visible" />
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </draggable>
                </div>
                <div class="fx-dash-editor-main-axis-line">
                  <div class="line-label">过滤条件</div>
                  <draggable
                    :sort="false"
                    :draggable="draggable"
                    :list="config.filter"
                    class="w-full h-full"
                    group="people1"
                    ghost-class="invisible"
                    @change="onFilterChange"
                  >
                    <div v-if="config.filter.length === 0" style="padding-left: 88px;font-size: 12px;color: gray;">
                      拖动左侧字段到此处来添加过滤条件
                    </div>
                    <ul v-else class="line-main filters-line">
                      <li v-for="(item, index) in config.filter" :key="index" class="axis-field">
                        <div>
                          <div class="fx-custom-dash-tag group">
                            <div class="tag-wrapper style-grey">
                              <i class="bi bi-chevron-down" />
                              <div class="text-wrapper">
                                <span class="tag-text">字段 等于任意一个 值</span>
                              </div>
                              <i class="bi bi-x-circle-fill invisible group-hover:visible" />
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </draggable>
                </div>
                <component :is="config.type" :query="config" />
              </el-container>
              <el-aside class="border-l bg-gray-100" width="300px">
                <div v-for="item in Array(1).fill({})" class="py-2.5 px-5 leading-[30px]">
                  <div>
                    <div>
                      <div>
                        <div class="text-black cursor-pointer">
                          <i class="bi bi-chevron-down mr-[5px] text-[#5e6d82]" />操作权限
                        </div>
                        <div>
                          <div>
                            <div>
                              <div>
                                <el-checkbox>可导出数据</el-checkbox>
                              </div>
                            </div>
                            <div>
                              <div>
                                <el-checkbox>可打印表格数据</el-checkbox>
                              </div>
                            </div>
                            <div>
                              <div>
                                <el-checkbox>继承成员对单条数据的操作权限<i class="bi bi-info-circle-fill" /></el-checkbox>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-aside>
            </el-container>
          </el-main>
        </el-container>
      </div>
    </el-dialog>
    <el-dialog class="source-select" append-to-body width="40%" title="更改数据源" :visible.sync="SourceDialogVisible">
      <data-source-select v-model="config.form" @cancel="SourceDialogVisible=false" @input="onSourceChange" />
    </el-dialog>
  </div>
</template>

<script>
import VueInputAutowidth from 'vue-input-autowidth'
import Draggable from 'vuedraggable'
import {_qk_register_components_object} from './plugins/index'
import DataSourceSelect from './DataSourceSelect'
import axios from 'axios'
import zroute from '../../ziggy'
import {plugins} from './uitls'


export default {
  name: 'WidgetEditor',
  components: {
    DataSourceSelect,
    Draggable,
    ..._qk_register_components_object,
  },
  directives: {
    autowidth: VueInputAutowidth,
  },
  props: {
    fullscreen: {
      type: Boolean,
      default: false,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => ({}),
    },
    formName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      config: {...this.value, type: plugins[this.value.type]},
      SourceDialogVisible: false,
      draggable: false,
      fields: [],
      dialogVisible: this.visible,
    }
  },
  watch: {
    dialogVisible(val) {
      console.log('dialogVisible changed', val)
      this.$emit('update:visible', val)
    },
    // 'config.fields': {
    //   handler(val) {
    //     this.handlePreview()
    //   },
    //   deep: true,
    //   immediate: true,
    // },
  },
  created() {
    console.log('WidgetEditor created', this.value)
    this.getFormFields()
  },
  methods: {
    handlePreview() {
      axios.post(zroute('app.dash.preview', [zroute().params.app_id, this.config.form.id]), this.config).then(res => {
        console.log(res)
        this.data = res.data
      })
    },
    onSourceChange() {
      this.SourceDialogVisible = false
      this.getFormFields()
    },
    onSubmit() {
      console.log('widget editor submit', this.config)
    },
    getFormFields() {
      axios.get(zroute('app.form.fields', [zroute().params.app_id, this.config.form.id])).then(res => {
        // this.showFieldList = res.data.data
        this.fields = res.data.fields
      })
    },
    cloneAction(item) {
      return {
        name: item.name,
        tag: 'f_' + Date.now(),
        text: item.text,
        type: item.type,
      }
    },
    onDragMove(e) {
      console.log('onDragMove', e)
    },
    onDragChange(e) {
      console.log('onDragChange', e)
    },
    onDragStart(e) {
      this.draggable = true
      console.log('onDragStart', e)
    },
    onDragEnd(e) {
      this.draggable = false

      console.log('onDragEnd', e)
    },
    onDragMove1(e) {
      console.log('onDragMove1', e)
    },
    onDragChange1(e) {
      console.log('onDragChange1', e)
    },
    onDragStart1(e) {
      console.log('onDragStart1', e)
    },
    onDragEnd1(e) {
      console.log('onDragEnd1', e)
    },
    onFilterChange(e) {
      console.log('onFilterChange', e)
    },
  },
}
</script>

<style lang="scss" scoped>

::v-deep .el-dialog.is-fullscreen {
  .el-dialog__header {
    padding: 0;
    height: 60px;
    line-height: 60px;

    .el-dialog__headerbtn {
      display: none;
    }
  }

  .el-dialog__body {
    padding: 0;
    height: calc(100vh - 60px);
    width: 100%;
    color: black;
  }
}

.editor-head {
  background: #fff;
  box-shadow: 0 2px 5px 0 hsl(0deg 0% 39% / 15%);

  .nav-title {
    input {
      font-size: 16px;
      height: 30px;
      color: #1F2D3D;
      border: 0;
      border-bottom: dashed 1px #333;
      background-color: transparent;
    }

  }
}

.el-container, .el-main, .el-aside {
  height: 100%;
  overflow-y: auto;
}

.el-main {
  padding: 0;
  margin: 0;
}

.block-head {
  position: relative;
  margin: 10px 10px 0 20px;
  line-height: 30px;

  .head-right {
    position: relative;
    right: 0;
    float: right;
  }

  .head-right.right-link {
    color: #0db3a6;
    cursor: pointer;
  }
}

.block-list {
  padding: 5px 0;
  overflow: auto;
  font-size: 12px;

  .list-item.normal-item {
    cursor: default;
  }

  .list-item {
    height: 26px;
    padding: 0 20px;
    line-height: 26px;
    -webkit-transform: none !important;
    transform: none !important;
    cursor: move;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    .item-title {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    i {
      margin-right: 10px;
    }
  }
}

.block-auth {
  padding: 5px 10px 0 20px;

  .x-combo {

  }

  .auth-desc {
    margin-top: 5px;
    color: #91a1b7;
    font-size: 12px;
    line-height: 16px;
  }
}

.fx-dash-editor-main-axis-line {
  position: relative;
  width: 100%;
  max-height: 90px;
  margin-bottom: 10px;
  line-height: 34px;
  background: #fff;
  border: 1px dashed #d9d9d9;
  border-radius: 3px;

  .line-label {
    position: absolute;
    top: 0;
    left: 10px;
    z-index: 2;

    .x-combocheck {
      display: inline-block;
      width: 12px;
      margin-left: 5px;
      border: none;
      cursor: pointer;
      transition: border .2s ease;
    }
  }

  ul {
    margin: 0;
    padding: 0;
  }

  .line-main {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    line-height: 34px;
    min-height: 34px;
    max-height: 90px;
    padding: 2.5px 10px 2.5px 88px;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .axis-field {
    display: inline-block;
    max-width: 100%;
    margin: 2.5px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    .fx-custom-dash-tag {
      height: 24px;
      line-height: 24px;

      .tag-wrapper.style-green {
        color: #fff;
        background: #5d9cee;
      }

      .tag-wrapper.style-grey {
        color: #5e6d82;
        background: #eaf0fc;
      }

      .tag-wrapper {
        display: flex;
        padding: 0 6px;
        border-radius: 20px;
        cursor: pointer;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;

      }

      .text-wrapper {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        padding: 0 4px;
      }
    }
  }
}

.source-select {
  ::v-deep .el-dialog__body {
    padding: 0;
  }
}
</style>
